import { CounterHelper } from './counterHelper';

export class UnitConverter {
  public static minimalQuantity(unitId: string): number {
    if (CounterHelper.IsWholeUnit(unitId)) {
      return 1;
    } else {
      return 0.01;
    }
  }
}
